<ng-template #buttonContent>
  <ng-content></ng-content>
</ng-template>

@switch (type) {
  @case ('simple') {
    <button
      [type]="buttonType"
      mat-flat-button
      [color]="color"
      [disabled]="disabled"
      (click)="onButtonClick($event)"
    >
      {{ text }}
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      @if (!!icon) {
        <mat-icon class="raised-inline-icon" [inline]="true">{{
          icon
        }}</mat-icon>
      }
    </button>
  }
  @case ('raised') {
    <button
      [type]="buttonType"
      mat-raised-button
      [color]="color"
      [disabled]="disabled"
      (click)="onButtonClick($event)"
    >
      {{ text }}
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      @if (!!icon) {
        <mat-icon class="raised-inline-icon" [inline]="true">{{
          icon
        }}</mat-icon>
      }
    </button>
  }
  @case ('stroked') {
    <button
      [type]="buttonType"
      mat-stroked-button
      [color]="color"
      [disabled]="disabled"
      (click)="onButtonClick($event)"
    >
      {{ text }}
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </button>
  }
  @case ('fab') {
    <button [type]="buttonType" mat-fab [color]="color" [disabled]="disabled">
      @if (!!icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      {{ text }}
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </button>
  }
  @case ('icon') {
    <button
      [type]="buttonType"
      mat-icon-button
      [color]="color"
      [disabled]="disabled"
      (click)="onButtonClick($event)"
    >
      <div class="flex flex-row items-center">
        <mat-icon>{{ icon }}</mat-icon>
        {{ text }}
      </div>
    </button>
  }
  @case ('icon-text') {
    <button
      [type]="buttonType"
      mat-button
      [color]="color"
      [disabled]="disabled"
      (click)="onButtonClick($event)"
    >
      <div class="flex flex-row items-center">
        <mat-icon class="mr-1">{{ icon }}</mat-icon>
        {{ text }}
      </div>
    </button>
  }
}
